import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@material-ui/core';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CustomButton from 'src/components/widgets/buttons/CustomButton';
import { useState } from 'react';
import { userApi } from 'src/api/userApi';

interface RejectProductionDialogProps {
    open: boolean;
    onClose: () => void;
    onReject: (reason: string) => void;
}

const RejectProductionDialog = ({ open, onClose, onReject }: RejectProductionDialogProps) => {
    const [reason, setReason] = useState('');
    const handleSubmit = () => {
        onReject(reason);
    };

    function uploadAdapter(loader) {
        return {
            upload: () =>
                new Promise((resolve) => {
                    loader.file.then(async (file) => {
                        const formData = new FormData();
                        formData.append('file', file);
                        const image = await userApi.uploadAttachments(formData);
                        resolve({
                            default: `${image?.data?.blob_url}`,
                        });
                    });
                }),
        };
    }

    function uploadPlugin(editor) {
        editor.plugins.get('FileRepository').createUploadAdapter = (loader) =>
            uploadAdapter(loader);
    }

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                <span style={{ fontSize: '18px', fontWeight: '700' }}>
                    Reject for Production
                </span>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want to reject this case for production? Please provide a reason for rejecting:
                </DialogContentText>
                <div data-color-mode="light" className="editorMarkup">
                    <CKEditor
                        editor={ClassicEditor}
                        data={reason}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            setReason(data);
                        }}
                        config={{
                            placeholder: 'Enter your reason for rejection',
                            toolbar: [
                                'heading',
                                '|',
                                'bold',
                                'italic',
                                'link',
                                'bulletedList',
                                'numberedList',
                                'blockQuote',
                                'uploadImage',
                            ],
                            extraPlugins: [uploadPlugin],
                        }}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Cancel
                </Button>
                <CustomButton
                    value="Reject"
                    onClick={handleSubmit}
                    color="primary"
                />
            </DialogActions>
        </Dialog>
    );
};

export default RejectProductionDialog; 